module.exports = __webpack_public_path__ + "img/emergency.25a5ce6f.gif";